import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import List from '../../../../../List'

import { SUMMARY_ATTRIBUTION_1_7 } from './helpers'

import { formatNumber } from '../../../../../../../helpers/numbers'

import useStyles from './styles'

const AttributionList = React.memo(({ attributions }) => {
  const classes = useStyles()

  const itemsListColumns = useMemo(
    () => [
      {
        field: 'title',
        style: {
          textAlign: 'left',
          paddingRight: '0', // avoid long titles cut
          minWidth: 140
        }
      },
      {
        Component: ({ value }) => formatNumber(value),
        style: {
          textAlign: 'right'
        }
      }
    ],
    []
  )

  return (
    <>
      <h3 className={classes.attributionsTitle}>Attribution Windows</h3>
      <div>
        <List
          hideHeadlineColumns={true}
          cols={itemsListColumns}
          listData={attributions}
          elementType="div"
          rowTemplate={{
            getRowClassName: rowData => rowData.id === SUMMARY_ATTRIBUTION_1_7 && classes.summaryRow,
            rowClassName: classes.attributionRow,
            skipMinHeight: true
          }}
        />
      </div>
    </>
  )
})

AttributionList.propTypes = {
  attributions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ).isRequired
}
export default AttributionList
